import { chatAction } from "../../firebase/chatPreferences";

export async function enterCall(room, person, callType, details = {}) {
  return (
    await chatAction("joinCall", {
      roomId: room.id,
      callType,
      mic: person.mic,
      camera: person.camera,
      spaceId: details.spaceId || null,
      stationId: details.stationId || null,
      otherUid: details.otherUid || null,
      expectedCallId: details.expectedCallId || null,
    })
  ).callId;
}
export const exitCall = (room, _uid, callId) =>
  callId
    ? chatAction("leaveCall", { roomId: room.id, callId })
    : Promise.resolve();
export const notifyCallMembers = ({ room, callId, isActive }) =>
  isActive()
    ? chatAction("notifyCall", { roomId: room.id, callId })
    : Promise.resolve();
